module.exports = __webpack_public_path__ + "static/media/utilidades.59035811.svg";